const Industriesdata = [
    {
        id : "1",
        schemeName: "Pharmaceutical Promotion Development Scheme, Department of Pharmaceuticals",
        discription:"The Department of Pharmaceuticals was created on the 1st of July in the year 2008 in the Ministry of Chemicals and Fertilizers so as to provide greater focus for the growth of the high potential Pharmaceuticals industry.         ",
        launchDate: "1 july 2008.",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Implementation of Scheme for Schedule M Compliance for SSI Pharma Units, Department of Pharmaceuticals",
    discription:"As per the second supplement of the Revised Guidelines issued by MSME on the Credit Linked Capital Subsidy Scheme (CLCSS) for Technology Up-gradation of Micro, Small and Medium Enterprises by the Ministry of MSME on 13th July, 2009 the pharma SSI units will now be able to avail the benefits of CLCS Scheme for financial assistance for an expanded list of products. ",
    launchDate: " 20-Dec-2019",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Group Insurance Scheme (GIS), Ministry of Textile",
    discription:"The Government of India had introduced the Group Insurance Scheme for Powerloom Weavers from 1st July, 2003 which is a combination of Janshree Bima Yojana (JBY) and Add-on Group Insurance Scheme (AGIS)? The Scheme was revised w.e.f. 1st January, 2008 and the revised Scheme was known as Group Insurance Scheme for Powerloom Weavers. This Scheme is implemented in collaboration with the Life Insurance Corporation of India.",
    launchDate: "27-Dec-2016",
    AnualFund: "12345"},

    {id : "3",
    schemeName: "National Metallurgist Award Scheme, Ministry of Steel",
    discription:"Background of the Scheme: National Metallurgists Day Awards, was instituted in 1962 by the then Ministry of Steel & Mines to recognise & honour the outstanding contributions of Metallurgists in the metallurgical field covering operation, research, design, education, waste management and energy conservation.",
    launchDate: "12-Sept-2022 ",
    AnualFund: "12345"},
]

export default Industriesdata;